"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GroupedProductItem;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _client = require("@sart/client");
var _content = require("@sart/content");
function GroupedProductItem(props) {
  var product = props.product,
    disabled = props.disabled,
    onPress = props.onPress,
    style = props.style,
    placeholderStyle = props.placeholderStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    descriptionStyle = props.descriptionStyle,
    imageColor = props.imageColor,
    name = props.name,
    iconType = props.iconType,
    description = props.description;
  var content = (0, _content.useContent)();
  var type = iconType !== undefined ? iconType : 'grouped';
  var imageColorStyle = imageColor ? imageColor : _styles.colors.white;
  var price = [];
  product.map(function (addon) {
    if (addon.recurring == true) {
      price.push(addon.recurringCost);
    } else if (addon.recurring == false) {
      price.push(addon.upfrontCost);
    }
  });
  var sortedPrices = price.sort(function (a, b) {
    return a - b;
  });
  var code = product[0].currency;
  var minPrice = sortedPrices[0];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: [styles.container, style],
    onPress: onPress,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.placeholder, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_icons.ProductIconType, {
    type: type,
    color: imageColorStyle
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title, titleStyle]
  }, name), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.price, priceStyle]
  }, content.addons.startingFrom), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), minPrice && code && /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: minPrice,
    style: [styles.price, priceStyle],
    code: code
  }))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.itemSubHeaderItemStyle
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle]
  }, description))));
}
GroupedProductItem.propTypes = {
  product: _propTypes["default"].array,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.subtle,
    overflow: 'hidden'
  },
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.srGreen
  },
  body: {
    flex: 1,
    paddingHorizontal: 12,
    paddingVertical: 6,
    justifyContent: 'center'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: 14,
    lineHeight: 24,
    fontWeight: 'bold',
    color: _styles.colors.exisBlue
  },
  price: {
    fontSize: 14,
    lineHeight: 24,
    fontWeight: 'bold',
    color: _styles.colors.exisDarkCharcoal
  },
  description: {
    fontSize: 14,
    lineHeight: 16,
    color: _styles.colors.common
  },
  itemSubHeaderItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});